<template>
  <el-row type="flex" class="buttonsWrap" justify="space-between">
    <div class="buttonsWrap-left">
      <slot />
    </div>

    <div class="buttonsWrap-right">
      <slot name="right" />
    </div>
  </el-row>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.buttonsWrap {
  padding: 10px 0 20px 0;
}
</style>
